import { useEffect, useState } from "react";
import Button from "../../../componentes/button/button";
import MainCard from "../../../componentes/card/MainCard";
import { motion } from "framer-motion";
import { Dialog } from "primereact/dialog";
import CargaEntregaService from "../../../services/resource/escalaDeRotaService";
import CalendarInline from "../../../componentes/calendar/Calendar";
import { WiStars } from "react-icons/wi";
import DropDown from "../../../componentes/dropdown/dropdown";
import FilialService from "../../../services/resource/filialService";
import { useAuth } from "../../../context/authContext";
import FuncionarioService from "../../../services/resource/funcionarioService";
import VeiculoService from "../../../services/resource/veiculoService";
import dayjs from "dayjs";
import EditarCargaEntrega from "./EditarEscalaDeRota";
import ImportacaoEscalaDeRota from "./ImportacaoEscalaRota";
import TabelaEscalaDeRotas from "./TabelaEscalaDeRotas";
import ResumoEscalas from "./ResumoEscalas";
import VisualizarEscalaDeRota from "./VisualizarEscalaDeRota";
import CadastrarEscalaRota from "./CadastrarEscalaDeRota";
import Input from "../../../componentes/input/input";
import DateMasked from "../../../componentes/inputMask/DateMasked";
import { data } from "autoprefixer";
import { toast } from "react-toastify";

function EscalaDeRotaMain() {
    const FileDownload = require('js-file-download');

    const cargaService = new CargaEntregaService();
    const filialService = new FilialService();
    const funcionarioService = new FuncionarioService();
    const veiculoService = new VeiculoService();

    const { user } = useAuth();

    const [showModalOperacao, setShowModalOperacao] = useState(false);
    const [lista, setLista] = useState([]);
    const [filiais, setFiliais] = useState([]);
    const [loading, setLoading] = useState(false);
    const [range, setRange] = useState({ start: null, end: null });
    const [filialId, setFilialId] = useState(user.filialId);
    const [selectedRow, setSelectedRow] = useState(null);
    const [showEditDialog, setShowEditDialog] = useState(false);
    const [showCreateDialog, setShowCreateDialog] = useState(false);
    const [showDeleteAllDialog, setShowDeleteAllDialog] = useState(false);
    const [loadgingDelete, setLoadingDelete] = useState(false);
    const [confirmDeleteText, setConfirmDeleteText] = useState("");
    const [dataOperacao, setDataOperacao] = useState("");
    const [showViewDialog, setShowViewDialog] = useState(false);
    const [listaMotoristas, setListaMotoristas] = useState([]);
    const [listaAuxiliares, setListaAuxiliares] = useState([]);
    const [listaVeiculos, setListaVeiculos] = useState([]);
    const [highlightDates, setHighlightDates] = useState([]);
    const [mesAtual, setMesAtual] = useState(dayjs().format("YYYY-MM"));

    useEffect(() => {
        document.title = "MyDash | Escala de Rotas";

        filialService.listar({ tipoDistribuidor: 'LOGISTICO' }).then(res => setFiliais(res.data));
    }, []);

    useEffect(() => {
        if (range.start && range.end) {
            buscarEscalaDeRotas(range.start, range.end);
        }
    }, [range, filialId]);

    useEffect(() => {
        buscarFuncionarios();
        buscarVeiculos();
    }, [filialId])

    useEffect(() => {
        buscarDiasDoMes();
    }, [mesAtual, filialId]);

    const buscarDiasDoMes = async () => {

        const inicio = dayjs(mesAtual + "-01").startOf("month").format("YYYY-MM-DD");
        const fim = dayjs(mesAtual + "-01").endOf("month").format("YYYY-MM-DD");

        const dias = await cargaService.listarDiasPorPeriodo(filialId, inicio, fim);

        setHighlightDates(dias.data);
    };

    const buscarEscalaDeRotas = async (dataInicio, dataFim) => {
        setLoading(true);
        const params = {
            start: dataInicio,
            end: dataFim,
            filialId: filialId
        };

        await cargaService.listar(params).then(res => {
            setLista(res.data)
        }).catch(e => {
            console.error(e)
        }).finally(() => {
            setTimeout(() => setLoading(false), 500)
        });
    };

    const exportarPlanilha = (modelo, dataInicio, dataFim) => {
        setLoading(true);
        const params = {
            start: dataInicio || range.start,
            end: dataFim || range.end,
            filialId: filialId,
            modelo: modelo
        };

        cargaService.exportarPlanilha(params).then(res => {
            const contentDisposition = res.headers["content-disposition"];

            let fileName = "planilha.xlsx";

            if (contentDisposition) {
                const match = contentDisposition.match(/filename="?(.+)"?/);
                if (match?.length > 1) {
                    fileName = match[1];
                }
            }

            FileDownload(res.data, fileName);
        }).finally(() => setLoading(false));
    };

    const atualizarCargaNaLista = (cargaAtualizada) => {
        setLista((prevLista) =>
            prevLista.map((item) =>
                item.id === cargaAtualizada.id ? cargaAtualizada : item
            )
        );
    };

    // Troca de data pelo modal de edição: a carga sai da lista se o novo dia ficou fora do período exibido
    const aoAlterarDataOperacao = (cargaAtualizada) => {
        setShowEditDialog(false);
        const dentro = (!range.start || cargaAtualizada.dataOperacao >= range.start)
            && (!range.end || cargaAtualizada.dataOperacao <= range.end);

        setLista(prev => dentro
            ? prev.map(item => (item.id === cargaAtualizada.id ? cargaAtualizada : item))
            : prev.filter(item => item.id !== cargaAtualizada.id));
        buscarDiasDoMes();
    };

    const buscarFuncionarios = async () => {
        await funcionarioService.listarMotoristas(filialId).then(res => setListaMotoristas(res.data));
        await funcionarioService.listarAuxiliaresDeCarga(filialId).then(res => setListaAuxiliares(res.data));
    };

    const buscarVeiculos = async () => {
        await veiculoService.listarByFilial(filialId).then(res => setListaVeiculos(res.data));
    };

    const handleDeleteAllPedidos = () => {
        setLoadingDelete(true);
        cargaService.excluirPorDia({
            filialId: filialId,
            data: dataOperacao
        }).then(res => {
            toast.success("Pedidos excluídos com sucesso!");
            closeModalDelete();
            if (range.start & range.end) buscarEscalaDeRotas(range.start, range.end);
        }).catch(e => {
            console.error(e.response.data.message);
        }).finally(() => setLoadingDelete(false))
    }

    const closeModalDelete = () => {
        setShowDeleteAllDialog(false);
        setConfirmDeleteText("");
        setDataOperacao(null)
    }

    const viewOnHide = () => {
        setShowViewDialog(false);
        setTimeout(() => {
            setSelectedRow(null);
        }, 100);
    }

    const header = <div className="flex gap-2">
        {!user.perfis.includes('COMISSOES') &&
            <DropDown
                name="filialId"
                options={filiais}
                optionLabel="nome"
                optionValue="id"
                value={filialId}
                filter={false}
                disabled={loading}
                onChange={(e) => setFilialId(e.value)}
            />
        }
        <div className="flex items-end">
            <Button label="Importar Operação" variant="indigo" iconLeft="fa fa-plus" onClick={() => setShowModalOperacao(true)} />
        </div>
    </div>;

    const title = <div>Escala de Rotas - {filiais.findLast(item => item.id === filialId)?.nome || null}</div>

    return (
        <div>
            <MainCard
                title={title}
                header={header}>

                <div className="p-2 px-4">

                    {/* TOOLBAR */}
                    <div className="
                        flex flex-col xl:flex-row xl:items-center xl:justify-between
                        gap-3 
                        rounded-2xl p-2 px-0
                    ">

                        {/* AJUDA */}
                        <div className="flex items-start gap-2 text-sm text-muted-foreground">
                            <WiStars className="text-xl text-amber-500 mt-[1px] shrink-0" />

                            <div>
                                <span className="font-medium text-foreground">
                                    Seleção rápida:
                                </span>

                                <span className="ml-1">
                                    clique duas vezes na mesma data para selecionar apenas um dia.
                                </span>
                            </div>
                        </div>

                        {/* LEGENDAS */}
                        <div className="flex flex-wrap items-center gap-3 cursor-default">

                            <div className="
                                flex items-center gap-2
                                bg-card border border-border rounded-full
                                px-3 py-1.5
                                text-xs text-muted-foreground
                                shadow-card
                            ">
                                <div className="w-3 h-3 rounded-full bg-primary"></div>
                                <span>Período selecionado</span>
                            </div>

                            <div className="
                                flex items-center gap-2
                                bg-card border border-border rounded-full
                                px-3 py-1.5
                                text-xs text-muted-foreground
                                shadow-card
                            ">
                                <div className="w-3 h-3 rounded-full bg-amber-500"></div>
                                <span>Dias com escala cadastrada</span>
                            </div>

                        </div>
                    </div>

                    {/* CONTEÚDO */}
                    <div className="grid grid-cols-1 xl:grid-cols-12 gap-6">

                        <motion.div
                            key={'range'}
                            initial={{ opacity: 0, y: 5 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.2 }}
                            className="xl:col-span-4 flex flex-col"
                        >
                            <CalendarInline
                                cardClassName="
                                rounded-2xl
                                shadow-card
                                border border-border
                                p-3 px-4
                                bg-card
                                hover:shadow-soft
                                transition-all duration-150
                            "
                                mode="range"
                                rangeValue={range}
                                onRangeChange={setRange}
                                highlightDates={highlightDates}
                                onMonthChange={(mes) => setMesAtual(mes)}
                            />
                        </motion.div>

                        <div className="xl:col-span-8">
                            <ResumoEscalas lista={lista} loading={loading} />
                        </div>
                    </div>
                </div>

                <Dialog
                    header={"Carga " + selectedRow?.carga}
                    visible={showViewDialog}
                    onHide={viewOnHide}
                    blockScroll
                    className="w-[98%]"
                    contentClassName="p-0"
                >
                    <VisualizarEscalaDeRota escala={selectedRow} onHide={viewOnHide} onEdit={() => {
                        setShowEditDialog(true);
                        setShowViewDialog(false);
                    }}
                    />
                </Dialog>

                <Dialog
                    header={
                        <div className="mb-2">
                            <h1 className="text-2xl font-bold font-display text-foreground">
                                Importação de Escalas de Rota
                            </h1>

                            <p className="text-sm text-muted-foreground mt-1">
                                Faça upload da planilha para importar cargas e entregas.
                            </p>
                        </div>
                    }
                    visible={showModalOperacao}
                    onHide={() => setShowModalOperacao(false)}
                    className="w-[98%] h-full"
                    blockScroll={true}
                >
                    <ImportacaoEscalaDeRota
                        perfis={user.perfis}
                        filiais={filiais} idFilial={filialId} onSuccess={() => {
                            buscarDiasDoMes();
                        }}
                    />
                </Dialog>

                <Dialog
                    header={`Cadastar nova carga`}
                    visible={showCreateDialog}
                    className="w-[95%]"
                    blockScroll
                    onHide={() => setShowCreateDialog(false)}
                >

                    <CadastrarEscalaRota
                        onClose={(carga) => {
                            setShowCreateDialog(false);
                            buscarDiasDoMes();
                            atualizarCargaNaLista(carga);
                        }}
                        onCloseDelete={(carga) => {
                            setShowCreateDialog(false);
                            setLista(prev =>
                                prev.filter(item => item.id !== carga.id)
                            );
                        }}
                        veiculos={listaVeiculos}
                        motoristas={listaMotoristas}
                        auxiliares={listaAuxiliares}
                        filiais={filiais}
                        idFilial={filialId}
                    />

                </Dialog>

                <Dialog
                    header="Exclusão do dia"
                    visible={showDeleteAllDialog}
                    className="w-[95%] md:w-[550px]"
                    blockScroll
                    onHide={closeModalDelete}
                >
                    <div className="space-y-5 mt-2">

                        <div className="flex items-start gap-3 rounded-lg border border-destructive/30 bg-destructive/10 p-4">
                            <i className="pi pi-exclamation-triangle text-destructive text-3xl mt-1" />
                            <div>
                                <h3 className="font-semibold text-destructive">
                                    Atenção! Esta ação é irreversível.
                                </h3>

                                <p className="text-sm text-foreground mt-2">
                                    Todos os <strong>pedidos cadastrados informados </strong>
                                    serão removidos permanentemente.
                                </p>

                                <p className="text-sm text-foreground mt-2">
                                    Essa operação <strong>não poderá ser desfeita</strong>.
                                    Certifique-se de que realmente deseja continuar.
                                </p>
                            </div>
                        </div>

                        <DateMasked
                            label="Informe a Data de Operação"
                            value={dataOperacao}
                            onChange={(e) => setDataOperacao(e)}
                            placeholder="Digite a data da Operação"
                        />

                        <Input
                            label={"Para confirmar, digite o nome da Filial: " + filiais.find(x => x.id === filialId)?.nome}
                            value={confirmDeleteText}
                            onChange={(e) => setConfirmDeleteText(e.target.value)}
                            placeholder={"Digite " + filiais.find(x => x.id === filialId)?.nome}
                            helpText="A exclusão só será habilitada após a confirmação do Texto."
                        />

                        <div className="flex justify-end gap-2 pt-3">
                            <Button
                                label="Cancelar"
                                variant="white"
                                onClick={closeModalDelete}
                            />

                            <Button
                                label="Excluir Todos os Pedidos"
                                iconLeft="fa fa-trash"
                                variant="red"
                                loading={loadgingDelete}
                                disabled={(confirmDeleteText.trim().toUpperCase() !== filiais.find(x => x.id === filialId)?.nome) || (dataOperacao.length !== 10)}
                                onClick={handleDeleteAllPedidos}
                            />
                        </div>

                    </div>
                </Dialog>

                <Dialog
                    header={`Editar Carga: ${selectedRow?.carga}`}
                    visible={showEditDialog}
                    className="w-[95%]"
                    blockScroll
                    onHide={() => setShowEditDialog(false)}
                >
                    {selectedRow && (
                        <EditarCargaEntrega
                            carga={selectedRow}
                            onClose={(carga) => {
                                setShowEditDialog(false);
                                atualizarCargaNaLista(carga);
                            }}
                            onDataAlterada={aoAlterarDataOperacao}
                            onCloseDelete={(carga) => {
                                setShowEditDialog(false);
                                setLista(prev =>
                                    prev.filter(item => item.id !== carga.id)
                                );
                            }}
                            veiculos={listaVeiculos}
                            motoristas={listaMotoristas}
                            auxiliares={listaAuxiliares}
                            filiais={filiais}
                            idFilial={filialId}
                        />
                    )}
                </Dialog>

            </MainCard>

            <div className="px-3 mb-3">
                <TabelaEscalaDeRotas
                    lista={lista}
                    loading={loading}
                    exportSheet={exportarPlanilha}
                    showCreate={() => setShowCreateDialog(true)}
                    showDeleteAll={() => setShowDeleteAllDialog(true)}
                    veiculos={listaVeiculos}
                    motoristas={listaMotoristas}
                    auxiliares={listaAuxiliares}
                    dataInicio={range.start}
                    dataFim={range.end}
                    onUpdated={atualizarCargaNaLista}
                    onEdit={(item) => {
                        setSelectedRow(item);
                        setShowEditDialog(true);
                    }}
                    onView={(item) => {
                        setSelectedRow(item);
                        setShowViewDialog(true);

                    }}
                />
            </div>
        </div>
    )
}

export default EscalaDeRotaMain;

